// extracted by mini-css-extract-plugin
module.exports = {"orderReservationList":"OrderReservationList_orderReservationList_2360R","isStyleDingBeauty":"OrderReservationList_isStyleDingBeauty_s7-Du"};